// Ícone "i" com balão explicativo no hover — usar ao lado de números/títulos que precisam de
// uma nota de rodapé rápida (ex: como um % é calculado), sem ocupar espaço permanente na tela.
export default function InfoTooltip({ texto }) {
  return (
    <span className="info-tooltip" tabIndex={0}>
      <span className="ms info-tooltip__icone" aria-hidden="true">info</span>
      <span className="info-tooltip__balao" role="tooltip">{texto}</span>
    </span>
  );
}
